module.exports = __webpack_public_path__ + "img/training_mix6.9fd4f8cd.jpg";